export type SubmissionVerdictInput = {
  disqualified?: boolean | null;
  admin_approval?: string | null;
  pre_approval?: string | null;
};

export type SubmissionVerdictKey = 'disqualified' | 'approved' | 'disapproved' | 'pre_approved' | 'pending';

/**
 * Single source of truth for "what status is this submission in", shared by
 * the verdict badge and the mobile-visible left accent bar so both always
 * agree — mirrors the inline logic that used to live only in the badge cell.
 *
 * Precedence: `disqualified` wins over everything. Then a real admin
 * decision (`approved` / `disapproved`) wins over the automatic
 * pre-approval gate — a human's verdict must never be masked by it. Only
 * when `admin_approval` is still `neutral` does `pre_approval ===
 * 'pre_approved'` surface as its own key; otherwise the submission is
 * `pending`.
 */
export function getSubmissionVerdictKey(s: SubmissionVerdictInput): SubmissionVerdictKey {
  if (s.disqualified) return 'disqualified';
  const approval = s.admin_approval || 'neutral';
  if (approval === 'approved') return 'approved';
  if (approval === 'disapproved') return 'disapproved';
  if (s.pre_approval === 'pre_approved') return 'pre_approved';
  return 'pending';
}
